import { StackProps, VStack } from "@chakra-ui/react"
import { ReactNode } from "react"
import { Header } from "../components/Header"
import { PageContent } from "../components/PageContent"
import { Footer } from "../components/Footer";

interface DefaultTemplateProps extends StackProps {
    children: ReactNode;
    activeNav?: 'HOME' | 'EXPLORE' | 'GENRE' | 'MERCHANDISE' | 'ABOUT_US' | 'HELP_CENTER';
    hero?: ReactNode;
}

export const DefaultTemplate = ({ children, hero, activeNav = 'HOME' }: DefaultTemplateProps) => {
    return (
        <VStack w={'full'} spacing={0}>
            <Header activeNav={activeNav} />
            {hero}
            <PageContent>
                {children}
            </PageContent>
            <Footer />
        </VStack>
    )
}